import {NgModule, CUSTOM_ELEMENTS_SCHEMA, Component} from '@angular/core';
import {AppModule} from '../app/application/app.module';
import {StoreModule} from '@ngrx/store';
import {rootReducer} from '../app/stateManagement/rootReducer';
import {StoreUndoModule} from 'ngrx-undo';
import { RouterStoreModule } from '@ngrx/router-store';

import { VersionCheckerService } from '../app/shared/services/version-checker.service';

@Component({
    selector: 'tr-application-wrapper',
    template: `
        <tr-application></tr-application>
    `
})
export class ApplicationWrapperContainerComponent {
    constructor(private versionCheckerService: VersionCheckerService) {
        //versionCheckerService.start();
    }
}

@NgModule({
    imports: [StoreModule.provideStore(rootReducer), StoreUndoModule.interceptStore({bufferSize: 100}), AppModule, RouterStoreModule.connectRouter()],
    declarations: [ApplicationWrapperContainerComponent],
    bootstrap: [ApplicationWrapperContainerComponent],
    schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class ProdModule {
}



// WEBPACK FOOTER //
// ./src/setup/prod.module.ts